<script lang="ts">
  import { loginAuth0 } from "$lib/services/auth0";
  import { isAuthenticated, project, user, isUserVerified } from "$lib/services/store";
  import Icons from "$lib/main/components/Icons.svelte";
  import { getTranslatedText } from "$lib/data/translations";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";

  export let tournamentImage;

  const tournamentRoute = $project.settings.tournamentsUrl ?? "turneringar";
  async function login() {
    await loginAuth0(`/${tournamentRoute}`);
  }

  async function signup() {
    await loginAuth0(`/${tournamentRoute}`, "signup");
  }

  const title = getTranslatedText("Auth popup title");
  const authedText = [
    $isUserVerified ? "" : getTranslatedText("Auth popup user not verified text"),
    ($user?.marketingConsent && $user?.messageConsent) ? "" : getTranslatedText("Auth popup no marketing consent text"),
  ]
    .filter(Boolean)
    .join("<br />");

  const text = $isAuthenticated ? authedText : getTranslatedText("Auth popup not authenticated");
</script>

<div class="no-auth-container">
  <img src={tournamentImage} alt="" class="visual-bg" referrerpolicy="no-referrer" />

  <div class="no-auth-card cta-container">
    <h3 class="card-title">{@html title}</h3>
    <p class="card-text">{@html text}</p>
    <ul class="card-info-list">
      <li class="card-info-item">
        <Icons name="star" strokeWidth="1" width="44" height="44" />
        <span>Spela gratis</span>
      </li>
      <li class="card-info-item">
        <Icons name="zap" strokeWidth="1" width="44" height="44" />
        <span>Tävla mot<br />andra spelare</span>
      </li>
      <li class="card-info-item">
        <Icons name="trophy" strokeWidth="1" width="44" height="44" />
        <span>Högst poäng vinner</span>
      </li>
    </ul>

    {#if $isAuthenticated}
      <a
        role="button"
        tabindex="0"
        aria-label="My account"
        class="card-button"
        href={"/profile"}
        data-element="my_profile"
      ><Translate text="My profile" /></a>
    {:else}
      <div class="buttons-div">
        <a
          role="button"
          tabindex="0"
          aria-label="Logga in"
          class="card-button"
          data-element="sign_up"
          href="#"
          on:click={() => signup()}>
          <Translate text="Sign up" />
        </a>
        <a
          role="button"
          tabindex="0"
          aria-label="Logga in"
          class="card-button"
          data-element="sign_in"
          href="#"
          on:click={() => login()}>
          <Translate text="Log in" />
        </a>
      </div>
    {/if}
  </div>
</div>

<style lang="postcss">
  .no-auth-container {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 600px;
    overflow: hidden;
  }

  .visual-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: blur(4px);
    object-fit: cover;
    user-select: none;
  }

  .no-auth-card {
    width: 90%;
    background-color: #000;
    border-radius: 0.5rem;
    padding: 1rem;
    z-index: 1;

    @media (min-width: 768px) {
      width: 360px;
    }
  }

  .card-title {
    font-weight: 400;
    margin: 0 0 1rem;
  }

  .card-text {
    font-size: 14px;
    margin-bottom: 1rem;
  }

  .card-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 3.5rem;
    color: var(--clr-cta-txt);
    background: var(--clr-cta);
    text-transform: uppercase;
    font-size: 14px;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;

    &:hover {
      color: var(--clr-cta-txt);
    }
  }

  .card-info-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 0 2rem;
    padding: 0;
    list-style: none;
  }

  .card-info-item {
    text-align: center;
    font-size: 12px;
    display: flex;
    gap: 5px;
    flex-direction: column;
    align-items: center;
  }

  .buttons-div {
    display: flex;
    flex-flow: column;
    gap: 10px;
  }
</style>
